<template>
  <dropdown-select
    :options="languages"
    :value="activeLanguage"
    :label="$t('languages.label')"
    name="language"
    @input="change" />
</template>

<script>
import DropdownSelect from '../components/UI/DropdownSelect'

export default {
  name: 'LangMenu',
  components: { DropdownSelect },
  computed: {
    languages () {
      return Object.keys(this.$i18n.messages).reduce((res, k) => {
        res[k] = this.$t(`languages.${k}`) || k.toUpperCase()
        return res
      }, {})
    },
    activeLanguage () {
      return this.$i18n.locale
    }
  },
  methods: {
    change (value) {
      this.$emit('change', value)
      this.$i18n.locale = value
    }
  }
}
</script>
